// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoLabel_container__DloAY","label":"InfoLabel_label__3it2w","value":"InfoLabel_value__2gQQv"};